import InputAdornment from '@mui/material/InputAdornment';
export default InputAdornment;
export * from '@mui/material/InputAdornment';
